import { Box, Button, Stack } from "@mui/material";

import { styled } from "@mui/material/styles";

export const ModalTitleContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));

export const ConfirmationButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
}));

export const ModalSortContainer = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(3),
  display: "flex",
  gap: theme.spacing(3),
  alignItems: "center",
}));

export const ModalFilterContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  marginBottom: theme.spacing(3),
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  alignItems: "center",
}));

export const InputStack = styled(Stack)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("tablet")]: {
    flexDirection: "row",
  },
  [theme.breakpoints.up("desktop")]: {
    flexDirection: "row",
  },
  width: "100%",
  columnGap: theme.spacing(3),
  alignItems: "center"
}));
